export default "__VITE_ASSET__1KshKRk___"